import React, { useState, Fragment, useEffect} from "react";
import axios from "axios";
import axiosInstance from "./../../helpers/axiosInstance";
import { Route, Redirect, useHistory, BrowserRouter, Switch } from "react-router-dom";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Button,
    NavLink,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    CardTitle,
    UncontrolledTooltip,
} from "reactstrap";

const Calendario=(props)=>{
    const [value, onChange] = useState(new Date());
    let diasSemana=["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"];
    let meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
    //console.log(value.getDay() + "/" + value.getMonth() + "/" + value.getFullYear());
    //console.log(props);
    useEffect(()=>{
        props.cambio(value);
    })
    if(props.muestra){
        return(
            <CardBody className="pb-1 justify-content-center text-xs-center">
                <Row className="justify-content-center">
                    <Container fluid>
                        <CardTitle
                        tag="h5"
                        className="text-uppercase mb-4 text-success"
                        >
                            Fecha de proyección
                        </CardTitle>
                    </Container>
                </Row>
                <Row className="justify-content-center">
                    <Container fluid>
                        <Calendar
                            onChange={onChange}
                            value={value}
                        />
                    </Container>
                </Row>
                <Row className="mt-4 mb-2 justify-content-center">
                    <Container fluid>
                        <span className="h4">{diasSemana[value.getDay()]}, {value.getDate()} de {meses[value.getMonth()]} del {value.getFullYear()}</span>
                    </Container>
                </Row>
            </CardBody>

        );

    }else{
        return(
            <Fragment>
                <div>
                    
                </div>
            </Fragment>
        );

    }
}
export default Calendario;